import { useEffect, useState } from 'react';

export const useTopbarHeight = (enabled: boolean) => {
	const [topbarHeight, setTopbarHeight] = useState('0px');

	useEffect(() => {
		if (!enabled || typeof window === 'undefined') return;

		const updateTopbarHeight = () => {
			const value =
				document.documentElement.style.getPropertyValue('--topbar-height') ||
				getComputedStyle(document.documentElement).getPropertyValue(
					'--topbar-height',
				) ||
				'0px';

			// Парсим значение (убираем 'px' и проверяем на ноль)
			const numericValue = parseFloat(value);
			setTopbarHeight(numericValue > 0 ? value : '0px');
		};

		updateTopbarHeight();

		const observer = new MutationObserver(updateTopbarHeight);
		observer.observe(document.documentElement, {
			attributes: true,
			attributeFilter: ['style'],
		});

		const resizeObserver = new ResizeObserver(updateTopbarHeight);
		resizeObserver.observe(document.documentElement);

		return () => {
			observer.disconnect();
			resizeObserver.disconnect();
		};
	}, [enabled]);

	return topbarHeight;
};
